(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('donate', donate);

    /* @ngInject */
    function donate($rootScope) {
        var directive = {
            bindToController: true,
            templateUrl: 'donate.tpl',
            controller: donateController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '='
            }
        };
        return directive;

        function link(scope, element, attrs) {
            var formSection = scope.vm.data.query[0].customs.layout.sections.find(function(e) {
                return e.type.value == 'form';
            });

            scope.vm.formFields = formSection.form.fields;
            scope.vm.formData = formSection.form.data;

            if(typeof $rootScope.selectedSeller !== 'undefined') {
                if (typeof scope.vm.formData.source == 'undefined') {
                    scope.vm.formData.source = {
                        seller: {value: ''}
                    };
                }
                scope.vm.formData.source.seller.value = $rootScope.selectedSeller;
            }
            scope.vm.tabs = scope.$root.getField(scope.vm.formFields, ['tab']).choices.filter(function(t) {
                // return t.value != 'gift' || scope.$root.globals.site_options.gift_settings.hide_gift_tab == "show";
                return t.value != 'gift' || scope.$root.safeChain(scope.$root.globals.site_options, 'shopping_cart_settings,hide_gift_tab') == "show";
            });

        }
    }

    /* @ngInject */
    function donateController ($scope, $location) {
        $scope.vm.total = {
            pie: 0,
            amount:0
        };
        $scope.switchTab = function(e) {
            var button = angular.element(e.target);
            var tab = button.data('tab');
            if (tab != 'donate') {
                $location.url('/shopping-cart/');
                $scope.$root.shoppingCartActiveTab = tab;
            }
        };
        // $scope.$watch('vm.data.query[0].customs.layout.sections[0].form.data.donation.pie.value', function(v) {
        $scope.$watch('vm.formData.donation.pie.value', function(v) {
            $scope.vm.total.pie = parseInt((!v ? 0 : v) * $scope.$root.globals.site_options.shopping_cart_settings['pie-price']);
            $scope.displayTotal();
            if ($scope.$root.project_has_opt('dedication')) {
                var dfield = $scope.$root.getField($scope.vm.formFields, ['dedication']);
                if (v > 0) {
                    dfield['c-logic'] = [];
                } else {
                    dfield['c-logic'] = [{ path: 'no-path',operator: '==', value: 'no-val', relation: 'or'}];
                }
                var rfield = $scope.$root.getField($scope.vm.formFields, ['dedication', 'recipients']);
                rfield.max = v;
            }
        });
        // $scope.$watch('vm.data.query[0].customs.layout.sections[0].form.data.donation.amount.value', function(v) {
        $scope.$watch('vm.formData.donation.amount.value', function(v) {
            $scope.vm.total.amount = parseInt(!v ? 0 : v);
            $scope.displayTotal();
        });
        $scope.displayTotal = function() {
            var billing = angular.element('[field-key="billing"]');
            var total = billing.find('.total');
            if (total.length == 0) {
                total = angular.element('<h6 class="total pd-donate-total"></h6>').insertAfter(billing.find('h5'));
            }
            total.text('Total: $' + ($scope.vm.total.pie + $scope.vm.total.amount));
            window.cartTotal = $scope.vm.total.pie + $scope.vm.total.amount;
        };

        if ($scope.$root.project_has_opt('dedication')) {
            $scope.$watch('vm.formData.dedication.recipients.length', function(newLen, oldLen) {
                console.log($scope.vm.formData.dedication);
                console.log(newLen, oldLen);
                if ((newLen > 1) && (newLen > oldLen)) {
                    var isCopy = $scope.$root.safeChain($scope.vm.formData, 'dedication,recipients, 0, copy, value');
                    if (isCopy) {
                        var source  = $scope.$root.safeChain($scope.vm.formData, 'dedication, recipients, 0, message, value');
                        var target = $scope.$root.safeChain($scope.vm.formData, 'dedication, recipients, ' + (newLen - 1) + ', message');
                        target.value = source;
                    }
                    angular.element('[parent-path="dedication,recipients,' + (newLen - 1) + '"][field-key="copy"]').hide();
                }
            }, true);

            $scope.$watch('vm.formData.dedication.recipients[0].copy.value', function(newVal, oldVal) {
                if (!oldVal && newVal) {
                    var source  = $scope.$root.safeChain($scope.vm.formData, 'dedication, recipients, 0, message, value');
                    var len = $scope.$root.safeChain($scope.vm.formData, 'dedication, recipients').length;
                    for(var i = 1; i < len; i++) {
                        $scope.$root.safeChain($scope.vm.formData, 'dedication, recipients, ' + i + ', message').value = source;
                    }
                }
            });
        }
    }
})();